var _path, _tspan, _tspan2, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPptx2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.97,
    height: 20.9,
    viewBox: "0 0 17.97 20.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "file"
  }, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.8,22.2c-.3,0-.7-.1-1-.1A3.61,3.61,0,0,1,3.6,19a7.08,7.08,0,0,1-.1-1.4V6a5.54,5.54,0,0,1,.2-1.8A3.5,3.5,0,0,1,6.8,1.5a14.08,14.08,0,0,1,2-.1h5a1,1,0,1,1,.1,1.9H7.2A1.75,1.75,0,0,0,5.5,5V18.1a1.7,1.7,0,0,0,.1.7,1.62,1.62,0,0,0,1.6,1.4h8.7a5.7,5.7,0,0,0,1.3-.1,1.7,1.7,0,0,0,1.4-1.5c0-.4.1-.7.1-1.1V11.9a1.14,1.14,0,0,1,.3-.8.91.91,0,0,1,1.5.3c0,.1.1.1.1.2v6.6c0,.2-.1.5-.1.7A3.61,3.61,0,0,1,17.3,22c-.3,0-.7.1-1,.1C13.4,22.2,10.6,22.2,7.8,22.2Z",
    transform: "translate(-3.45 -1.35)",
    fill: "#2c2c2c",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.1
  })), /*#__PURE__*/React.createElement("text", {
    transform: "translate(5.88 7.35) rotate(-0.27)",
    fontSize: 5.5,
    fill: "{props.color}",
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700,
    style: {
      isolation: "isolate"
    }
  }, "pp", _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 6.82,
    y: 0,
    letterSpacing: "0.01em"
  }, "t")), _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 9.04,
    y: 0,
    letterSpacing: "0em"
  }, "x"))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.91,6.72",
    transform: "translate(-3.45 -1.35)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5,18",
    transform: "translate(-3.45 -1.35)",
    fill: "none",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPptx2);
export default __webpack_public_path__ + "static/media/pptx2.2b27516b716c12e5e06258c0a5b88a1b.svg";
export { ForwardRef as ReactComponent };